/* ARN cart helpers: showLoader/hideLoader (used by arn-bundle-cart-sync.js), cart drawer review slider restart,
   cart plan dropdown (.subscription-group). Moved out of layout/theme.liquid 1 Oct 2026, loaded deferred after vendor-scripts (jQuery). */
function showLoader() {
        $('#custom-loader').show();
      }

      function hideLoader() {
        setTimeout(() => {
          $('#custom-loader').hide();
        }, 2200);
      }

      document.addEventListener('DOMContentLoaded', function () {
        // Cart drawer review slider: start it again after a +/- click re-renders the drawer
        $('#CartContainer').on('click', 'button.js-qty__adjust--minus, button.js-qty__adjust--plus', function () {
          setTimeout(() => {
            var $slider = $('.cart-drawer-review__slider');
            if ($slider.length && !$slider.hasClass('slick-initialized')) {
              $slider.slick({
                autoplay: true,
                autoplaySpeed: 2000,
                speed: 600,
                draggable: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              });
            }
          }, 2200);
        });
      });
    

  
    document.addEventListener('DOMContentLoaded', function() {
      $(document).on('change', '.subscription-group', function() {
        showLoader();
        // console.log('change');
        var $select = $(this);
        var sellingPlanId = $select.val();
        var lineItemKey = $select.data('line-item-key');
        var variantId = $select.data('variant-id');
        var quantity = $select.data('quantity');

        // console.log('sellingPlanId', sellingPlanId, lineItemKey);
        // First, get the current item properties
        var itemProperties = {}; 
        $.getJSON('/cart.js', function(cart) {
          var currentItem = cart.items.find(function(item) {
            return item.key === lineItemKey;
          });

          if (currentItem) { 
            itemProperties = currentItem.properties;
          }
          // console.log('itemProperties',currentItem, itemProperties);

          // Now, remove the existing item from the cart
          var updates = {
            id: lineItemKey,
            quantity: 0 // Remove the old item first
          };

          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: JSON.stringify(updates),
            dataType: 'json',
            contentType: 'application/json',
            success: function() {
              // Then add it back with the new selling plan and properties
              var addData = {
                id: variantId,
                quantity: quantity,
                properties: itemProperties // Add original properties
              };

              if (sellingPlanId !== "") {
                addData.selling_plan = sellingPlanId;
              }

              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify(addData),
                dataType: 'json',
                contentType: 'application/json',
                success: function() {
                  // Refresh cart drawer (or fetch new cart content)
                  document.dispatchEvent(new CustomEvent('cart:refresh'));
                  $("body").trigger("added.ajaxProduct");
                },
                error: function(xhr, status, error) {
                  console.error('Error adding new item:', error);
                }
              });
            },
            error: function(xhr, status, error) {
              console.error('Error removing item:', error);
            }
          });
          hideLoader();
        });
      });
    });
